<template>
  <b-container>
    <base-section>
      <b-row>
        <b-col>
          <base-subheading>Keine Internetverbindung.<br>Bitte überprüfen Sie Ihre E-Mails und drucken Sie die Liste der Bestellungen von Kindern aus</base-subheading>
        </b-col>
      </b-row>
    </base-section>
  </b-container>
</template>

<script>
import BaseSubheading from "@/components/base/Subheading";
import BaseSection    from "@/components/base/Section";
export default {
  name:       'Offline',
  components: {BaseSection, BaseSubheading},
}
</script>
